import React from "react";
import { HOST_URL } from "../../../../../actions/api";
import { FontAwesomeIcon } from "../../../../CommonComponents/AssetsHelper";
import { Button } from "react-bootstrap";

const options = [
    "Didn't find the features useful?",
    "Got concerns regarding security and compliance.",
    "Didn't find the UI attractive.",
    "Frequent bugs and errors.",
    "Anything else."
]
const Technical = ({ setTechnicalValue, technicalValue, error, setError }) => {
    const { feedbackOption, feedbackContent } = technicalValue;

    return (
        <div className="p-md-10 p-5 bg-gray rounded">
            <div className="">
                <h6>Could you specify the issue you are experiencing with Tagbox?</h6>
                <ul className="options-list ms-3 mt-5">
                    {options.map(item => <li key={item}>
                        <div className="radio d-inline-flex" >
                            <input type="radio" name="technical" checked={feedbackOption == item} onChange={() => {
                                setTechnicalValue(prevState => ({ ...prevState, feedbackOption: item }));
                                setError(false);
                            }} />
                            <label className="radio-label">{item}</label>
                        </div>
                    </li>)}
                    {(feedbackOption != 'Anything else.' && error) && <span id="feedsfield2error" className="errorMessage required">Please select an option</span>}
                    {feedbackOption == 'Anything else.' && <><textarea className="form-control" placeholder="Enter your feedback" rows="3" value={feedbackContent} onChange={(e) => {
                        setTechnicalValue(prevState => ({ ...prevState, feedbackContent: e.target.value }));
                        setError(false);
                    }} />
                        {(error && feedbackContent.length == 0) ? <span id="feedsfield2error" className="errorMessage required">This field is required</span> : null}
                    </>}
                </ul>
                <div className="alert alert-custom fade show mt-6 mb-0 bg-light-gray rounded-0 p-4 align-items-start rounded-2">
                    <div className="alert-icon py-1 f-center pe-0">
                        <FontAwesomeIcon type={'solid'} icon={'info'} iconClass={'fs-6 me-2'} />
                        <div className="d-flex justify-content-center align-items-start flex-column flex-grow-1">
                            <p className="mb-4">Apologies for any inconvenience! We want to ensure a smooth experience. Could you share more details about the technical issues you've encountered? Our team is here to assist.</p>
                            <div className="d-flex">
                                <Button variant="primary" onClick={() => window.open(`https://calendly.com/taggbox/demo?utm_source=Widget&utm_medium=${HOST_URL}/widget/&utm_campaign=calendly_Request_demo_click`, '_blank')}>
                                    <FontAwesomeIcon type={'regular'} icon={'headset'} iconClass={'text-white me-2'} />
                                    Book Call</Button>
                                <Button variant="dark" className="ms-2" onClick={() => window.Intercom ? window.Intercom('show'): null}>
                                    <FontAwesomeIcon type={'regular'} icon={'comment'} iconClass={'text-white me-2'} />
                                    Talk To Us</Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Technical;